import Icon from "../components/common/Icon"

 
export const AisScreenLoader = () => {
    return (
        <div className="overlays">
          <Icon name="ais-loader" alt="ais-loader " size={60}/>
        </div>
    )
}